<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
        v-row(no-gutters)
          v-col
            .h6.basic800--text {{ $t('manage_forms') }}

      v-card-text.pa-0
        v-form(ref="form")
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          .selet-member-layout(v-else-if="!isFetching")
            .p1.primary500--text.px-6.mt-4(v-if="count") {{ $t('count_text', { count }) }}
            v-list.py-4
              template(v-for="(form, index) in forms")
                v-list-item.mx-2(:key="form.id")
                  v-list-item-content
                    v-list-item-title {{ form.name }}
                    v-list-item-subtitle 
                      span.body-2.grey--text.text--darken-1.mb-0.mr-2 {{ $t('products') }}: {{ form.products.length }}
                      span.body-2.grey--text.text--darken-1.mb-0.mr-2 {{ $t('clicks') }}: {{ form.total_clicks }}
                      span.body-2.grey--text.text--darken-1.mb-0 {{ $t('sales') }}: {{ form.total_sales | displayPrice }}
                  v-list-item-action
                    y-checkbox(v-model="form.selected" @change="updateForm(form, index)")
                v-divider
      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-medium.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click='showModal = false')
          .button-AA-small.basic100--text {{ $t('save') }}

</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'EditFormModal',
    props: ['open', 'company', 'count'],
    data: () => ({
      isFetching: false,
      forms: [],
      isLoading: false,
      companyName: '',
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required']
      }
    }),
    computed: {
      showModal: {
        get() {
          return this.open
        },
        set(newValue) {
          this.$emit('update:open', newValue)
        }
      }
    },
    mounted () {
      this.fetchForms()
    },
    methods: {
      ...mapActions([
        'showMessage', 'updateCompany'
      ]),
      updateForm (form, index) {
        let status = 'draft'
        if (form.selected) {
          status = 'published'
        }
        this.$axios.patch(`/forms/${form.id}/`, { status: status})
          .then(() => {
            this.$axios.get(`/companies/${this.company.id}/`)
              .then(resp => {
                this.updateCompany(resp.data)
              })
          })
          .catch(() => {
            this.forms[index].selected = !this.forms[index].selected
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
      },
      fetchForms() {
        this.isFetching = true
        let url = `/forms/?page=1&page_size=-1&company=${this.company.id}&ordering=-total_sales&type_exclude=store&layout_exclude=landing`
        this.$axios.get(url)
          .then((response) => {
            this.isFetching = false
            response.data.results.forEach(form => {
              const newForm = form
              newForm.selected = false
              if (form.status == 'published') {
                newForm.selected = true
              }
              this.forms.push(newForm)
            })
          })
          .catch(() => {})
      }

    }
  }
</script>

<style lang="scss" scoped>

</style>

<i18n>
{
  "en": {
    "count_text": "Only {count} forms are allowed for this plan"
  },
  "id": {
    "count_text": "Hanya {count} form yang diizinkan untuk paket ini"
  }
}
</i18n>
